const intialState = {
  targetSiteERPMap: {},
  loading: false,
  error: null
};

const targetsiteErpMappingReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_TARGETSITE_ERP_MAPPING_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_TARGETSITE_ERP_MAPPING_SUCCESS':
      return {
        ...state,
        loading: false,
        targetSiteERPMap: action.payload.data
      };
    case 'GET_TARGETSITE_ERP_MAPPING_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};
export default targetsiteErpMappingReducer;
